<template>
  <div
    class="mobile-menu-bar sticky hidding-toolbar"
    :class="{ 'hidding-toolbar--hidden': !showNavbar }"
  >
    <b-navbar
      class="is-glassy is-hidden-tablet"
      :close-on-click="true"
    >
      <template slot="brand">
        <div class="columns px-2 py-2 mb-1 is-mobile is-gapless is-vcentered logo-box">
          <div class="column logo-holder">
            <b-image
              :src="require('@/assets/logo.svg')"
              alt="qlipmark"
              class="logo"
            />
          </div>
          <div class="column is-flex-grow-0 has-text-primary logo-text">
            qlipmark
          </div>
        </div>
      </template>

      <template slot="end">
        <template v-if="logged">
          
          <MainMenuContents />
         
          <ActionsMenuContents />
        </template>
      </template>

    </b-navbar>
    <slot />
  </div>
</template>

<script>
  import { hiddingOnScroll } from '@/mixins/hiddingOnScroll'
  import MainMenuContents from "@/views/_globals/MenuContents-Main.vue"
  import ActionsMenuContents from "@/views/_globals/MenuContents-Actions.vue"
  import { mapGetters } from 'vuex'

  export default {
    name: 'MenuBar',
    mixins: [ hiddingOnScroll ],
    computed: {
      ...mapGetters({
        logged: 'auth/logged',
      }),
    },
    components: {
      MainMenuContents,
      ActionsMenuContents,
    }
  }
</script>

<style lang="scss" scoped>
  .mobile-menu-bar {
    margin-bottom: 20px;
  }

  .logo-holder {
    max-width: 50px;
  }
</style>
